export const getFile = state => state.file;
export const getData = state => state.data;
export const getMappings = state => state.mappings;
export const getSettings = state => state.settings;
export const getCurrentStep = state => state.currentStep;
export const getEnrichmentStatus = state => state.enrichmentStatus;
export const getListDetails = state => state.listDetails;
export const getSheetName = state => state.sheetName;
export const getType = state => state.type;
export const getDataEnrichmentId = state => state.dataEnrichmentId;
export const getError = state => state.error;
